//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const pants = [
    0, 0, 5, 5, 5, 5, 5, 5, 5, 5, 0, 0, 
    0, 0, 3, 3, 3, 1, 1, 3, 3, 3, 0, 0, 
    0, 0, 4, 3, 3, 1, 1, 3, 3, 4, 0, 0, 
    0, 0, 4, 2, 3, 3, 3, 3, 2, 4, 0, 0, 
    0, 0, 4, 2, 2, 0, 0, 2, 2, 4, 0, 0, 
    0, 0, 4, 2, 2, 0, 0, 2, 2, 4, 0, 0, 
    0, 0, 4, 2, 2, 0, 0, 2, 2, 4, 0, 0, 
    0, 0, 4, 2, 2, 0, 0, 2, 2, 4, 0, 0, 
    0, 0, 4, 2, 2, 0, 0, 2, 2, 4, 0, 0, 
    0, 0, 4, 2, 2, 0, 0, 2, 2, 4, 0, 0, 
    0, 0, 4, 4, 4, 0, 0, 4, 4, 4, 0, 0, 
    0, 0, 3, 3, 3, 0, 0, 3, 3, 3, 0, 0,
]
